module.exports = __webpack_public_path__ + "img/10.19c88474.jpg";